export default "/imgs/investigation-03.png"